/* eslint-disable @typescript-eslint/no-explicit-any */
import { notification } from 'antd'

import { AxiosErrorType } from '@types'

const onEnterOk = (onOk: () => void) => {
  window.onkeyup = (e: { key: string }) => {
    if (e.key === 'Enter') {
      onOk()
    }
  }
}

const boolTraduction = (bool: boolean) => (bool ? 'Sí' : 'No')

const convertBase64 = (file: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

const onErrorHandler = (err: unknown) => {
  const error = err as AxiosErrorType

  const { message } = error.data.error as {
    type: string
    status: number
    message: string
  }
  notification.error({
    message,
  })
}

const capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1)

const joinArrayValuesOnText = (array: any[], joiner = ' - ') => array.filter(Boolean).join(joiner)

export const OtherUtils = {
  onEnterOk,
  boolTraduction,
  convertBase64,
  onErrorHandler,
  capitalize,
  joinArrayValuesOnText,
}
